import { Element } from '@ritabygglov/core';
import { CommandManager } from '../commands/CommandManager';
import { UpdateCommand } from '../commands/UpdateCommand';

export const createUpdateChangeAction = (
  newElement: Element,
  oldElement: Element,
  ephemeral: boolean,
  commandManager: CommandManager,
  userId: string
) => {
  const command = new UpdateCommand(
    [newElement],
    [oldElement],
    userId,
    ephemeral
  );
  commandManager.executeCommand(command);
};
